import { Button } from "../design/components/Button";
import { Dialog } from "../design/components/Dialog";
import { Reason } from "../design/components/Reason";
import { useT } from "../i18n/locale";

// La conferma prima di accendere la giornata a blocchi di 30 minuti per un'azienda (piano M7, Task 7; D10; domanda n. 34, aperta): la
// vede soltanto il Super admin di Gioia365 nel contesto di piattaforma. Dice, con le parole del piano (R5), che cosa cambia per il team
// e quando va accesa; «Accendi» manda l'interruttore, «Annulla» (o Esc, o il fondo) chiude senza mandare niente. Un rifiuto del server
// resta nella finestra con il suo motivo (UX-7). Spegnere non chiede conferma: toglie una vista, non ne apre una.

type Props = {
  company: string;
  pending: boolean;
  failure: string | null;
  onConfirm: () => void;
  onClose: () => void;
};

export function WorkBlocksSwitchDialog({ company, pending, failure, onConfirm, onClose }: Props) {
  const t = useT();
  return (
    <Dialog open title={t("reports.blocks.confirmTitle", { company })} onClose={onClose}>
      <div className="g-report-blocks-dialog" aria-busy={pending || undefined}>
        {failure ? (
          <Reason tone="warning" role="alert">
            {failure}
          </Reason>
        ) : null}
        <p>{t("reports.blocks.confirm")}</p>
        <div className="g-report-blocks-dialog__actions">
          <Button variant="primary" onClick={onConfirm} disabled={pending}>
            {t("reports.blocks.confirmAction")}
          </Button>
          <Button onClick={onClose}>{t("common.cancel")}</Button>
        </div>
      </div>
    </Dialog>
  );
}
